
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitomalvancab() {



    const cardData =
    {
        keyword: ' Mumbai to Malvan Cab',
        heading: 'Deva Cabs: Mumbai to Malvan Cab',
        headingDescription: 'Deva Cabs provides reliable and comfortable cab services from Mumbai to Malvan, perfect for beach holidays, family trips, and cultural exploration. Covering a distance of approximately 550 km, our well-maintained vehicles—Sedans, SUVs, and Innova Crysta—ensure a smooth and scenic ride along the beautiful Konkan coast. Whether you are traveling solo, with friends, or family, you Will enjoy the convenience of experienced drivers, fixed‑fare packages, and flexible door‑to‑door pickups. With 24/7 availability, transparent pricing, and dedicated customer support, Deva Cabs makes your Mumbai to Malvan journey stress‑free, safe, and memorable.',

        top: 'Top Places to Visit in Malvan with Deva Cabs',

"topPlaces": [
  {
    "title": "Sindhudurg Fort",
    "location": "Malvan, Sindhudurg District, Maharashtra",
    "description": "This iconic island fortress, built by Shivaji Maharaj between 1664–67, boasts massive stone ramparts, bastions and secret passages right in the Arabian Sea. Accessible by boat, it's a living testament to Maratha naval power, offering panoramic sea views and historical intrigue."
  },
  {
    "title": "Tarkarli Beach",
    "location": "Tarkarli, Malvan, Sindhudurg District, Maharashtra",
    "description": "Renowned as the ‘Queen of Beaches’ on the Konkan coast, Tarkarli features silvery-white sand and crystal-clear blue waters. It's perfect for swimming, sunrise strolls, and water-sport adventures in a serene coastal setting."
  },
  {
    "title": "Malvan Marine Sanctuary",
    "location": "Malvan, Sindhudurg District, Maharashtra",
    "description": "India’s first marine sanctuary, this protected area encompasses coral reefs, sea turtles, exotic fish, and vibrant underwater habitats. It’s a snorkeler’s and diver’s paradise, accessible via guided boat tours from Malvan and Tarkarli."
  },
  {
    "title": "Rock Garden",
    "location": "Malvan, Sindhudurg District, Maharashtra",
    "description": "Perched on a rocky shoreline near the jetty, this laid-back garden blends landscaped seating areas and natural rock formations with sweeping views of the Arabian Sea—a peaceful spot for sunset photography and quiet reflection."
  },
  {
    "title": "Tsunami Island",
    "location": "Near Tarkarli, Malvan, Sindhudurg District, Maharashtra",
    "description": "This tiny sandbar island emerged after the 2004 tsunami and is now a popular hub for jet‑skiing, banana/bumper boat rides, parasailing and weekend getaways—reachable at low tide, then submerged again as waters rise."
  },
  {
    "title": "Devbagh Beach & Backwaters",
    "location": "Devbagh, Malvan, Sindhudurg District, Maharashtra",
    "description": "Where the Karli River meets the Arabian Sea, this calm backwater area is ideal for kayaking, birdwatching and peaceful boat rides. Its mangrove-fringed shores are perfect for spotting local wildlife and gentle river-sea confluence."
  },
  {
    "title": "Chivla & Bhogwe Beaches",
    "location": "Near Malvan, Sindhudurg District, Maharashtra",
    "description": "These lesser-known beaches offer quiet, unspoiled sandy stretches with lush coconut groves and gentle waves—excellent for morning walks, solitude, and experiencing natural coastal beauty without the crowds."
  },
  {
    "title": "Rameshwar Temple",
    "location": "Achara, Malvan, Sindhudurg District, Maharashtra",
    "description": "An ancient and serene Shiva temple in the coastal village of Achara, known for its traditional Konkan-style architecture and peaceful surroundings. A spiritual retreat amid rustling palms and sea breezes."
  },
  {
    "title": "Jay Ganesh & Bhardi Devi Temples",
    "location": "Malvan, Sindhudurg District, Maharashtra",
    "description": "These local shrines—dedicated to Lord Ganesh and Goddess Bhardi Devi—draw devotees and offer insight into the living cultural traditions of coastal Maharashtra, especially vibrant during local festivals."
  },
  {
    "title": "Nivati & Bharatgad Forts",
    "location": "Near Malvan, Sindhudurg District, Maharashtra",
    "description": "Offbeat sea and riverside forts—Nivati and Bharatgad—stand atop coastal creeks and hills. These ruins offer trekking, panoramic water views, and peaceful exploration of lesser-visited historical sites."
  }
],



  "services": [
    {
      "name": "Mumbai to Malvan Cab",
      "description": "Explore the scenic beauty of Maharashtra’s coastline with Deva Cabs' Mumbai to Malvan cab service. Ideal for beach holidays, scuba diving adventures, and historical sightseeing, our outstation cabs ensure a smooth and enjoyable ride. With experienced chauffeurs, clean vehicles, and doorstep pickup, we make your coastal journey safe, comfortable, and memorable. Perfect for family vacations, group tours, or solo escapes to the Konkan coast."
    },
    {
      "name": "Book cab Mumbai to Malvan online",
      "description": "Easily book your Mumbai to Malvan cab online through Deva Cabs. Our platform offers instant confirmation, real-time availability, and multiple cab options including sedans, SUVs, and luxury cars. Whether you're heading to the beach, exploring Malvan fort, or enjoying water sports, our seamless booking process makes planning your trip hassle-free."
    },
    {
      "name": "One-way cab Mumbai to Malvan",
      "description": "Deva Cabs offers reliable one-way taxi services from Mumbai to Malvan, tailored for travelers planning an extended stay or onward trip from Malvan. Enjoy competitive rates, punctual drivers, and door-to-door service—ideal for leisure travelers, tourists, and photographers visiting the Konkan region."
    },
    {
      "name": "Chauffeur-driven cab hire Mumbai to Malvan",
      "description": "Travel worry-free with our chauffeur-driven cab service to Malvan from Mumbai. Our drivers are well-versed with the Konkan routes and ensure a smooth, relaxed journey. Sit back, relax, and enjoy the scenic drive through coastal Maharashtra in a clean, air-conditioned vehicle."
    },
    {
      "name": "Round trip Malvan cab from Mumbai",
      "description": "Planning a quick getaway or a family beach retreat? Book a round trip cab from Mumbai to Malvan with Deva Cabs and enjoy flexible scheduling, waiting time, and return convenience. Ideal for weekend travelers and short coastal vacations with comfortable return options."
    },
    {
      "name": "SUV cab to Malvan from Mumbai",
      "description": "For a spacious and comfortable ride, book an SUV cab from Mumbai to Malvan. Our SUVs offer ample legroom and luggage space, making them perfect for group travel or family vacations. Enjoy the coastal highway with smooth suspension and a relaxing ride."
    },
    {
      "name": "Affordable Malvan cab hire Mumbai",
      "description": "Deva Cabs offers budget-friendly cab rentals for your Mumbai to Malvan journey without compromising on service or comfort. Transparent pricing, clean vehicles, and trained drivers ensure you get the best value for your travel experience."
    },
    {
      "name": "Luxury cab Mumbai to Malvan",
      "description": "Upgrade your coastal journey with a luxury cab from Mumbai to Malvan. Travel in style with premium vehicles equipped with plush interiors, extra legroom, and experienced chauffeurs. Ideal for special occasions, VIP travel, or beachside getaways in comfort and elegance."
    },
    {
      "name": "AC taxi Mumbai to Malvan",
      "description": "Beat the heat with our fully air-conditioned cabs on the Mumbai to Malvan route. Perfect for long drives through the coast, our AC taxis provide a cool and comfortable travel experience, whether you’re visiting beaches, temples, or historic forts."
    }
  ],
  "tableData": [
    ["Mumbai to Malvan Cab", "-Book cab Mumbai to Malvan online"],
    ["One-way cab Mumbai to Malvan", "-Chauffeur-driven cab hire Mumbai to Malvan"],
    ["Round trip Malvan cab from Mumbai", "-SUV cab to Malvan from Mumbai"],
    ["Affordable Malvan cab hire Mumbai", "-Luxury cab Mumbai to Malvan"],
    ["AC taxi Mumbai to Malvan", ""]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Malvan Cab Service",
    "WhyChoosedescription": "Plan a seamless journey from Mumbai to the pristine coastal town of Malvan with our trusted cab service. Whether you're headed for a beach retreat, water sports, or a visit to historical forts, we ensure a safe and relaxing ride over the 530+ km distance through the scenic Konkan region."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Our fleet includes premium sedans, SUVs, and tempo travellers designed to handle long highway and coastal drives. Enjoy air-conditioned cabins, plush seating, ample legroom, and generous luggage space as you travel in total comfort from Mumbai to Malvan."
  },
  {
    "WhyChooseheading": "Expert Drivers Familiar with Konkan Terrain and Attractions",
    "WhyChoosedescription": "Our experienced drivers are well-versed in the Mumbai–Malvan route and familiar with the terrain, traffic patterns, and sightseeing stops. They drive safely through winding roads and ghats while guiding you to local gems like Tarkarli Beach, Devbagh, and Sindhudurg Fort."
  },
  {
    "WhyChooseheading": "Flexible Travel Packages Tailored to Your Itinerary",
    "WhyChoosedescription": "Choose from one-way, round trip, or extended tour packages. Whether you're spending a weekend in Malvan or exploring the entire Konkan coast, we offer flexible rental options to match your schedule, including night travel, stopovers, and custom route planning."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "We provide upfront, all-inclusive pricing with no surprise charges. Your fare includes fuel, tolls, parking, and driver allowance, allowing you to plan your budget confidently and enjoy a worry-free travel experience."
  },
  {
    "WhyChooseheading": "24/7 Cab Availability to Match Your Travel Plans",
    "WhyChoosedescription": "Our services are available around the clock, so you can book a ride that fits your travel schedule perfectly. Whether you’re leaving at sunrise or late at night, we ensure your cab is ready and waiting."
  },
  {
    "WhyChooseheading": "Instant Booking with Easy Online and Offline Support",
    "WhyChoosedescription": "Book your Mumbai to Malvan cab in just a few clicks on our website or through our responsive customer care team. Receive instant confirmation with trip and driver details, ensuring a smooth and organized journey from the start."
  },
  {
    "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Vehicles",
    "WhyChoosedescription": "All vehicles are thoroughly sanitized before each trip and come equipped with GPS tracking, seat belts, and emergency kits. Your safety, hygiene, and comfort are our top priorities as you travel to Malvan with us."
  }
]













    }




const faqData = [
  {
    question: "Can I book a cab from Mumbai to Malvan with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and comfortable cab services from Mumbai to Malvan for sightseeing, beach holidays, and group trips."
  },
  {
    question: "How long does it take to travel from Mumbai to Malvan by cab?",
    answer: "The journey typically takes around 9 to 11 hours depending on traffic and road conditions."
  },
  {
    question: "What types of vehicles are available for Mumbai to Malvan travel?",
    answer: "We provide a variety of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your group size."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Malvan?",
    answer: "Yes, Deva Cabs offers both one-way and round-trip cab services for Mumbai to Malvan."
  },
  {
    question: "Are tolls, driver charges, and parking fees included in the fare?",
    answer: "Toll charges, parking fees, and driver allowances are usually extra and will be communicated upfront during booking."
  },
  {
    question: "Is the cab service to Malvan available 24/7?",
    answer: "Yes, you can book Mumbai to Malvan cab services any time as we operate round-the-clock."
  },
  {
    question: "Is it safe to travel long distances like Mumbai to Malvan by cab?",
    answer: "Absolutely. Our drivers are experienced and verified to ensure a safe and pleasant journey."
  },
  {
    question: "Can I customize the route or make stops during the trip?",
    answer: "Yes, you can request stops or sightseeing along the route when booking your cab."
  },
  {
    question: "Is the service suitable for families and groups?",
    answer: "Yes, our fleet and services cater to families, groups, and solo travelers alike."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Malvan travel?",
    answer: "Deva Cabs provides clean vehicles, professional drivers, transparent pricing, and excellent customer support for a hassle-free trip."
  }
];

const testimonialData = [
  {
    id: 79,
    name: 'Mr. Ramesh Patil',
    role: 'Tourist',
    review: 'Our Mumbai to Malvan trip with Deva Cabs was fantastic. The vehicle was spacious and the driver was very courteous.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 80,
    name: 'Ms. Kavita Desai',
    role: 'Family Traveler',
    review: 'Thanks to Deva Cabs, we enjoyed a comfortable and safe journey to Malvan. Highly recommended service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Malvan Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-malvan-cab.jpg", // Replace with actual image URL
  "description": "Book affordable Mumbai to Malvan cab online with chauffeur-driven SUVs and luxury taxis. Perfect for one-way and round trips with AC and comfortable rides.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "180",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-malvan-cab" // Replace with actual URL
  }
};





    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Malvan Cab | Book Malvan Taxi Online | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Mumbai to Malvan cab service with chauffeur-driven SUVs and luxury taxis. Book your one-way or round trip Malvan cab online with AC comfort."
  />
  <meta
    name="keywords"
    content="Mumbai to Malvan Cab, Book cab Mumbai to Malvan online, One-way cab Mumbai to Malvan, Chauffeur-driven cab hire Mumbai to Malvan, Round trip Malvan cab from Mumbai, SUV cab to Malvan from Mumbai, Affordable Malvan cab hire Mumbai, Luxury cab Mumbai to Malvan, AC taxi Mumbai to Malvan"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/49.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitomalvancab;